// extracted by mini-css-extract-plugin
module.exports = {"SlideImage":"BannerSlider_SlideImage__zdVC7","Container":"BannerSlider_Container__20B0I"};